<div id="container">
  <div id="warning" #warning *ngIf="showWarning">{{warningText}}</div>
  <div id="player" #player>
    <!-- <img #playButton src="https://img.icons8.com/ios/50/000000/play.png" alt="Start Streaming" (click)="onClickPlayButton()" *ngIf="playButtonVisible"/> -->
    @if(playButtonVisible){
    <div #playButton (click)="onClickPlayButton()">
      <!-- icon play -->
      <app-button-icon [iconName]="'play'"></app-button-icon>
    </div>
    }
    <div *ngIf="showControls" #controls class="controls-container dynamic"
      [class.active]="openChat || openTranslate || openDraw">
      <!-- <button class="control-element" id="balckButton" (click)="startAudio()">AUDIO</button> -->
      <div id="canvascontainer" class="control-element canvas-ctrl" (click)="toggleMic()" [class.active]="micon"
        [class.disabled]="!isDataChannelReady">
        <!-- mic icon -->
        <app-button-icon [iconName]="'mic'"></app-button-icon>
        <canvas #unityCanvas id="unity-canvas" width=160 height=48 tabindex="-1" *ngIf="showUnityCanvas"></canvas>
      </div>
      <!-- <button class="control-element" id="blueButton-" (click)="buttonClicked(ButtonsEnum.FreeHand)">Free Hand</button> -->
      <div class="element-bundle" id="drawContainer" #drawContainer [class.expanded]="openDraw" [class.disabled_]="!isDataChannelReady">
        <div class="drawarea" [class.active]="openDraw">
          <div class="control-element-unstyled" id="blueButton-" (click)="buttonClicked(ButtonsEnum.FreeHand)"
            [class.active]="buttonsActive.freehands" [class.disabled]="!isDataChannelReady">
            <!-- pencil icon -->
            <app-button-icon [iconName]="'freehand'"></app-button-icon>
          </div>
          <!-- <button class="control-element" id="greenButton-" (click)="buttonClicked(ButtonsEnum.Rectangle)">Rectangle</button> -->
          <div class="control-element-unstyled" id="greenButton-" (click)="buttonClicked(ButtonsEnum.Rectangle)"
            [class.active]="buttonsActive.rectangle" [class.disabled]="!isDataChannelReady">
            <!-- rectangle icon -->
            <app-button-icon [iconName]="'rectangle'"></app-button-icon>
          </div>
          <!-- <button class="control-element" id="orangeButton-" (click)="buttonClicked(ButtonsEnum.Circle)">Circle</button> -->
          <div class="control-element-unstyled" id="orangeButton-" (click)="buttonClicked(ButtonsEnum.Circle)"
            [class.active]="buttonsActive.circle" [class.disabled]="!isDataChannelReady">
            <!-- circle icon -->
            <app-button-icon [iconName]="'circle'"></app-button-icon>
          </div>
          <!-- <button class="control-element" id="purpleButton-" (click)="buttonClicked(ButtonsEnum.Arrow)">Arrow</button> -->
          <div class="control-element-unstyled" id="purpleButton-" (click)="buttonClicked(ButtonsEnum.Arrow)"
            [class.active]="buttonsActive.arrow" [class.disabled]="!isDataChannelReady">
            <!-- arrow icon -->
            <app-button-icon [iconName]="'arrow'"></app-button-icon>
          </div>
          <span class="divider"></span>
          <!-- <button id="redButton" (click)="buttonClicked(ButtonsEnum.Pencil)">Pencil</button> -->
          <!-- <button class="control-element" id="clearButton-" (click)="buttonClicked(ButtonsEnum.Clear)">Clear</button> -->
          <div class="control-element-unstyled" id="clearButton-" (click)="buttonClicked(ButtonsEnum.Clear)"
            [class.disabled]="!isDataChannelReady">
            <!-- clear icon -->
            <app-button-icon [iconName]="'erase'"></app-button-icon>
          </div>
          <div class="control-element-unstyled" (click)="colorPicker.click()" [class.disabled]="!isDataChannelReady">
            <!-- color icon -->
            <app-button-icon [iconName]="'colorpicker'" [colorPicker]="colorPicker.value"></app-button-icon>
            <input class="control-element" style="visibility:hidden;" type="color" id="html5colorpicker"
              autocomplete="off" #colorPicker value="#ff0000" (change)="onColorChange()">
          </div>

          <div class="control-element-unstyled" id="thicknessContainer" [class.disabled]="!isDataChannelReady">
            <!-- <label for="thickness">Thickness (between 1 and 10):</label> -->
            <!-- thickness icon-->
            <app-button-icon [iconName]="'fontsize'"></app-button-icon>
            <input type="range" id="thickness" autocomplete="off" #thickness value="3" min="1" max="10"
              (change)="onThicknessChange()">
          </div>

        </div> <!-- chiusura draw area -->

        <!-- pulsanti toggler-->
        <div class="control-element" (click)="toggleDraw()" [class.disabled]="!isDataChannelReady">
          @if(!openDraw){
          <app-button-icon [iconName]="'draw'"></app-button-icon>
          }@else{
          <app-button-icon [iconName]="'closedraw'"></app-button-icon>
          }
        </div>
      </div>
      <!-- chiusura container controlli disegno -->
      <!-- <div class="control-element" (click)="colorPicker.click()" [class.disabled]="!isDataChannelReady">
            <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" [style.fill]="colorPicker.value"><path d="m255-917 43-43 347.69 347.69Q669-589 669-555.37q0 33.62-23 56.37L468-321q-23 23-54 23t-54-23L182-499q-23-22.77-23-56.44 0-33.66 23-56.44L371-801 255-917Zm159 159L215-559h398L414-758Zm337.79 477Q722-281 701-302.15T680-353q0-17.35 8-37.17Q696-410 710-431q8-13 19.5-28t22.5-28q11 13 22.5 28t19.5 28q14 21 22 40.83 8 19.82 8 37.17 0 29.7-21.21 50.85-21.21 21.15-51 21.15ZM80 1v-121h800V1H80Z"/></svg>
            <input class="control-element" style="visibility:hidden;" type="color" id="html5colorpicker" autocomplete="off" #colorPicker value="#ff0000" (change)="onColorChange()"> 
          </div> -->
      <span class="divider"></span>
      <div class="control-element" id="clearButton-" (click)="takeScreenshot()" [class.disabled]="!isDataChannelReady">
        <app-button-icon [iconName]="'capture'"></app-button-icon>
      </div>
      <div *ngIf="isRecordingVisible" class="control-element" id="clearButton-" (click)="toggleRecording()" [class.active]="isRecording" [class.disabled]="!isRecording &&!isDataChannelReady">
        <app-button-icon [iconName]="'record'"></app-button-icon>
      </div>
      <span class="divider" *ngIf="canBlur || mustBlur"></span>
      <div class="control-element" id="clearButton-" (click)="toggleBlur()" [class.active]="isBlur" *ngIf="canBlur || mustBlur">
        <app-button-icon [iconName]="isBlur ? 'blur-off' : 'blur-on'"></app-button-icon>
      </div>
      <span class="divider"></span>
      <!-- message-->
      <div id="textareaContainer" #textareaContainer class="element-bundle" [ngClass]="{'expanded':openChat}" [class.disabled_]="!isDataChannelReady">
        <div class="textarea textarea-grid" [class.active]="openChat">
          <textarea class="textarea-form" id="textInput" autocomplete="off" #textInput rows="2" cols="125"
            (input)="handleTextAreaInput()"></textarea>
          <div class="textarea-counter" id="charCounter"><small>{{charCount}}</small></div>
          <div class="control-element-unstyled textarea-action" id="sendButton" autocomplete="off" #sendButton
            (click)="sendTextMessage()" [class.disabled]="!isDataChannelReady || textInput.value.length === 0">
            <app-button-icon [iconName]="'sendmessage'"></app-button-icon>
          </div>
        </div>
        <div class="control-element" id="chatButton-" (click)="toggleChat()" [class.disabled]="!isDataChannelReady">
          @if(!openChat){
          <app-button-icon [iconName]="'chat'"></app-button-icon>
          }@else{
          <app-button-icon [iconName]="'closedraw'"></app-button-icon>
          }

        </div>

        <!-- <button id="sendButton" autocomplete="off"  #sendButton (click)="sendTextMessage()">INVIA</button> -->
      </div>
      <span class="divider" *ngIf="isTranslateVisible"></span>
      <!-- translate-->
      <div class="element-bundle" *ngIf="isTranslateVisible" id="translateContainer" #translateContainer [class.disabled_]="!isDataChannelReady"
        [class.expanded]="openTranslate">
        <div class="translatearea" [class.active]="openTranslate">
          <div class="control-element" id="localTranslation" autocomplete="off" #localTranslation
            (click)="toggleLocalTranslation()" [class.active]="isLocalTranslating" [class.disabled]="!micon">
            <app-button-icon [iconName]="'mic'"></app-button-icon>
          </div>
          <div class="control-element select" id="selectLocalLanguage" autocomplete="off" #selectLocalLanguage>
            <select [(ngModel)]="sourceLanguage" (change)="handleSourceLanguageChange()"
              [disabled]="isLocalTranslating || isRemoteTranslating">
              <option *ngFor="let item of languages" [value]="item.value">{{ item.label }}</option>
            </select>
          </div>
          <div class="control-element select" id="selectRemoteLanguage" autocomplete="off" #selectRemoteLanguage>
            <select [(ngModel)]="targetLanguage" (change)="handleTargetLanguageChange()"
              [disabled]="isLocalTranslating || isRemoteTranslating">
              <option *ngFor="let item of languages" [value]="item.value">{{ item.label }}</option>
            </select>
          </div>
          <div class="control-element" id="remoteTranslation" autocomplete="off" #remoteTranslation
            (click)="toggleRemoteTranslation()" [class.active]="isRemoteTranslating">
            <app-button-icon [iconName]="'voice'"></app-button-icon>
          </div>
        </div>
        <div class="control-element" id="chatButton-" (click)="toggleTranslate()"
          [class.disabled]="!isTranslateEnabled || !isDataChannelReady">
          @if(!openTranslate){
          <app-button-icon [iconName]="'language'"></app-button-icon>
          }@else{
          <app-button-icon [iconName]="'closedraw'"></app-button-icon>
          }

        </div>

        <!-- <button id="sendButton" autocomplete="off"  #sendButton (click)="sendTextMessage()">INVIA</button> -->
      </div>

    </div>

    <app-videoplayer #videoplayer [showvideocontrols]="showVideoControls"></app-videoplayer>

    <!-- 
      @if(showVideo){
      <video id="Video" #elementVideo class="video-element" playsInline="true" [src]="videoSrc"></video>
      }
      -->

  </div>
  <div class="box" *ngIf="codecPreferencesShow">
    <span>Codec preferences:</span>
    <select id="codecPreferences" autocomplete="off" disabled #codecPreferences [disabled]="codecPreferencesDisabled"
      (change)="onCodecPreferencesChange($event)">
      <option selected value="">Default</option>
      <option *ngFor="let option of codecPreferencesOptions" [value]="option.value">{{option.text}}</option>
    </select>
  </div>

  <div class="box" *ngIf="lockMouseCheckShow">
    <span>Lock Cursor to Player:</span>
    <input type="checkbox" id="lockMouseCheck" #lockMouseCheck autocomplete="off" />
  </div>

  <div id="message" #message *ngIf="showMessage">{{messageText}}</div>
</div>

<!-- UNITY Audio streaming -->
<!-- <div id="canvascontainer">
    <canvas #unityCanvas id="unity-canvas" width=160 height=48 tabindex="-1" *ngIf="showUnityCanvas"></canvas>
  </div> -->